/* <mv-slider>: pijlknoppen voor een scroll-snap-baan (USA-thema, mv-testimonials en mv-product-videos).
   Opbouw:  <mv-slider> <button data-mv-vorige> <… data-mv-baan> <button data-mv-volgende> </mv-slider>
   - de baan scrollt zelf (touch, trackpad, toetsenbord); de pijlen schuiven één kaart op
   - past alles in beeld, dan krijgt het element [data-past] en verbergt de CSS de pijlen
   - in de theme editor scrollt een geselecteerd blok in beeld */
const zonderBeweging = window.matchMedia('(prefers-reduced-motion: reduce)');

class MvSlider extends HTMLElement {
  connectedCallback() {
    this.baan = this.querySelector('[data-mv-baan]');
    if (!this.baan) return;
    this.vorige = this.querySelector('[data-mv-vorige]');
    this.volgende = this.querySelector('[data-mv-volgende]');
    this.bijwerken = this.bijwerken.bind(this);
    this.opScroll = this.opScroll.bind(this);
    this.vorige?.addEventListener('click', () => this.schuif(-1));
    this.volgende?.addEventListener('click', () => this.schuif(1));
    this.baan.addEventListener('scroll', this.opScroll, { passive: true });
    this.addEventListener('shopify:block:select', (e) => {
      e.target.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'auto' });
    });
    this.waarnemer = new ResizeObserver(this.bijwerken);
    this.waarnemer.observe(this.baan);
    this.bijwerken();
  }

  disconnectedCallback() {
    this.waarnemer?.disconnect();
    this.baan?.removeEventListener('scroll', this.opScroll);
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  stap() {
    const kaart = this.baan.firstElementChild;
    if (!kaart) return this.baan.clientWidth;
    const tussen = parseFloat(getComputedStyle(this.baan).columnGap) || 0;
    return kaart.getBoundingClientRect().width + tussen;
  }

  schuif(richting) {
    this.baan.scrollBy({ left: richting * this.stap(), behavior: zonderBeweging.matches ? 'auto' : 'smooth' });
  }

  opScroll() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.bijwerken();
    });
  }

  bijwerken() {
    const max = this.baan.scrollWidth - this.baan.clientWidth;
    const links = Math.abs(this.baan.scrollLeft);
    this.toggleAttribute('data-past', max <= 1);
    if (this.vorige) this.vorige.disabled = links <= 1;
    if (this.volgende) this.volgende.disabled = links >= max - 1;
  }
}

if (!customElements.get('mv-slider')) customElements.define('mv-slider', MvSlider);
